import { useMemo } from "react";
import { useUserPermissions } from "../../../../SignIn/UserPermissionsContext";

export const useCanEditLicenceTabs = () => {
  const { userPermissions } = useUserPermissions();
  return useMemo(() => {
    const permissions = Array.isArray(userPermissions) ? userPermissions : [];
    return permissions.some((permission) => {
      const value = String(permission || "")
        .trim()
        .toLowerCase();
      return (
        value.includes("administrator") ||
        value.includes("licence certificates admin")
        // ||
        // value.includes("finance") ||
        // value.includes("compliance")
      );
    });
  }, [userPermissions]);
};

export const useCanViewLicenceTabs = () => {
  const { userPermissions } = useUserPermissions();
  return useMemo(() => {
    const permissions = Array.isArray(userPermissions) ? userPermissions : [];
    return permissions.some((permission) => {
      const value = String(permission || "")
        .trim()
        .toLowerCase();
      return (
        value.includes("administrator") ||
        value.includes("licence certificates")
        // ||
        // value.includes("finance") ||
        // value.includes("compliance")
      );
    });
  }, [userPermissions]);
};
